import { Box, useDisclosure } from "@chakra-ui/react"
import AugmentationLayout, {
  AugmentationLayoutProps
} from "@pathwright/ux/src/components/augmentation/AugmentationLayout"
import AugmentationRoutedPanel from "@pathwright/ux/src/components/augmentation/AugmentationRoutedPanel"
import {
  AugmentationToolbarOption,
  useAugmentationToolbar
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { useCanViewSimpleNav } from "../useCanViewUnifiedHome"
import HomeAugmentationPopover from "./HomeAugmentationPopover"
import { useHomeAugmentationToolbarOptions } from "./useHomeAugmentationToolbar"

const HomeAugmentationPopoverLayout = ({
  Primary
}: {
  Primary?: AugmentationLayoutProps["components"]["Primary"]
}) => {
  const { me } = usePathwrightContext()
  const canViewUnifiedHome = useCanViewSimpleNav()
  const options =
    useHomeAugmentationToolbarOptions() as AugmentationToolbarOption[][]

  const homeOption: AugmentationToolbarOption = {
    key: "home",
    label: "Home",
    icon: "avatar",
    renderIcon: (icon) => <UserAvatar user={me} size="xs" />,
    to: "/home"
  }

  const signOutOption: AugmentationToolbarOption = {
    key: "sign-out",
    label: "Sign Out",
    icon: "arrow-up-line",
    renderIcon: (icon) => <Box transform="rotate(-90deg)">{icon}</Box>,
    to: "/auth/sign-out"
  }

  const toolbar = useAugmentationToolbar(
    options.map((options, i) =>
      i === 0
        ? [homeOption, ...options]
        : i === options.length - 1
        ? [...options, signOutOption]
        : options
    )
  )

  const disclosure = useDisclosure()

  return canViewUnifiedHome ? (
    <AugmentationLayout
      components={{
        Primary,
        Panel: AugmentationRoutedPanel,
        Toolbar: HomeAugmentationPopover
      }}
      toolbar={toolbar}
      disclosure={disclosure}
      spacing={[40, 10, 10]}
      // padding={20}
      allowOverlay
      panelPosition="far"
    />
  ) : null
}

export default HomeAugmentationPopoverLayout
